//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters, mapActions } from 'vuex';
import formItem from '@/component/form-item.vue';

export default {
  components: {
    formItem
  },
  name: 'forgetPwd',
  data() {
    return {
      codetext: '获取验证码',
      clock: 9,
      disabled: false
    };
  },
  methods: {
    ...mapActions([]),
    getCode() {
      let that = this;
      if(that.codetext === '获取验证码') {
        this.disabled = true;
        this.codetext = '请' + that.clock + '秒后重试';
        var setClock = setInterval(function(){
          that.clock--;
          that.codetext = '请' + that.clock + '秒后重试';
        },1000)
        setTimeout(() => {
          clearInterval(setClock);
          that.codetext = '获取验证码';
          that.clock = 9;
          that.disabled = false;
        }, 9000);
      }
    }
  },
  watch: {},
  computed: {
    ...mapGetters([])
  },
  created() {},
  mounted() {
    let elem = document.querySelector('#vux_view_box_body');
    setTimeout(() => {
      elem.style.paddingBottom = '44px';
    }, 10);
  }
};
